import React from 'react'
import { FieldRenderProps } from 'react-final-form'
import { FormFieldProps, Form, Label } from 'semantic-ui-react'
import { DateTimePicker } from 'react-widgets';

interface IProps extends FieldRenderProps<Date, HTMLElement>, FormFieldProps { }

const DateInput: React.FC<IProps> = ({
  input,
  width,
  placeholder,
  date = false,
  time = false,
  meta: { touched, error },
  label,
  minDate,
  ...rest
}) => {
  return (
    <Form.Field error={touched && !!error} width={width}>
      {label && <label>{label}</label>}
      <DateTimePicker
        placeholder={placeholder}
        value={input.value || null}
        onChange={input.onChange}
        onBlur={input.onBlur}
        min={minDate}
        onKeyDown={(e) => e.keyCode !== 9 ? e.preventDefault() : null}
        date={date}
        time={time}
      // {...rest}
      />
      {touched && error && (
        <Label basic color='red' pointing='above'>
          {error}
        </Label>
      )}
    </Form.Field>
  )
}

export default DateInput
